<template>
  <div
    class="opple-progress"
  >
    <div
      class="opple-progress_main"
    >
      <div
        class="opple-progress_bg"
        :style="{width: progress}"
      ></div>
    </div>
    <p
      class="opple-progress_text"
    >
     {{ progress }}
    </p>
  </div>
</template>
<script>


export default {
  components: { 

  },
  props: {
    current: {
        type: Number,
        default: 0
      }
  },
  computed: {
    progress() {
      return Math.min(this.current, 100) + '%';
    },
  },

  data() {
    return {
      
    }
  },

  watch: {
    socketmodel (rs) {
    },
  },

  methods: {
   
  }
}
</script>

<style lang="scss">

.opple-progress {
  display: flex;
  align-items: center;

  &_main {
    position: relative;
    width: 75px;
    height: 20px;
    background: #EDF5FF;
    border-radius: 2px;
    opacity: 1;
    border: 1px solid #C4DDFD;
  }

  &_bg {
    height: 100%;
    background: #5F9DF1;
  }

  &_text {
    margin-left: 9px;
    font-size: 12px;
    color:  #5F9DF1;
  }
}
</style>
